<script>
  export let nightTheme = true;
  export let sidebarCollapsed;
</script>

<aside
  class="container"
  class:collapsed={$sidebarCollapsed}
  class:nightTheme
  on:click={(e) => {
    e.stopPropagation();
    sidebarCollapsed.set(false);
  }}
>
  <div class="sticky">
    <slot />
  </div>
</aside>

<style>
  .container {
    display: none;
  }

  @media only screen and (min-width: 600px) {
    .container {
      display: block;
      position: relative;
      padding: 0 32px 0;
      box-sizing: border-box;
      width: 320px;
      flex: 1 1 auto;
      height: 100%;
      transition: background-color ease-in-out 0.5s, width ease-in-out 0.5s;
      box-shadow: 10px 0px 10px -5px rgba(0, 0, 0, 0.25);
    }
  }

  .container:not(.nightTheme) {
    background-color: #eee;
  }

  .container.nightTheme {
    background-color: var(--night-dark);
    color: white;
  }

  .container.collapsed {
    width: 48px;
    cursor: pointer;
  }

  .sticky {
    position: sticky;
    top: 0;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
</style>
